// Comprehensive country configuration with all defaults
// Used for registration, profile settings, and configuration

export const COUNTRY_REGIONS = [
  {
    region: 'South Asia',
    countries: [
      { code: 'IN', name: 'India', phoneCode: '+91', currency: 'INR', dateFormat: 'DD-MM-YYYY', financialYear: 'apr-mar' },
      { code: 'PK', name: 'Pakistan', phoneCode: '+92', currency: 'PKR', dateFormat: 'DD-MM-YYYY', financialYear: 'jul-jun' },
      { code: 'BD', name: 'Bangladesh', phoneCode: '+880', currency: 'BDT', dateFormat: 'DD-MM-YYYY', financialYear: 'jul-jun' },
      { code: 'LK', name: 'Sri Lanka', phoneCode: '+94', currency: 'LKR', dateFormat: 'DD-MM-YYYY', financialYear: 'apr-mar' },
      { code: 'NP', name: 'Nepal', phoneCode: '+977', currency: 'NPR', dateFormat: 'DD-MM-YYYY', financialYear: 'jul-jun' },
    ]
  },
  {
    region: 'Southeast Asia',
    countries: [
      { code: 'SG', name: 'Singapore', phoneCode: '+65', currency: 'SGD', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'MY', name: 'Malaysia', phoneCode: '+60', currency: 'MYR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'TH', name: 'Thailand', phoneCode: '+66', currency: 'THB', dateFormat: 'DD/MM/YYYY', financialYear: 'oct-sep' },
      { code: 'ID', name: 'Indonesia', phoneCode: '+62', currency: 'IDR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'PH', name: 'Philippines', phoneCode: '+63', currency: 'PHP', dateFormat: 'MM/DD/YYYY', financialYear: 'jan-dec' },
      { code: 'VN', name: 'Vietnam', phoneCode: '+84', currency: 'USD', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
    ]
  },
  {
    region: 'East Asia',
    countries: [
      { code: 'JP', name: 'Japan', phoneCode: '+81', currency: 'JPY', dateFormat: 'YYYY-MM-DD', financialYear: 'apr-mar' },
      { code: 'CN', name: 'China', phoneCode: '+86', currency: 'CNY', dateFormat: 'YYYY-MM-DD', financialYear: 'jan-dec' },
      { code: 'KR', name: 'South Korea', phoneCode: '+82', currency: 'KRW', dateFormat: 'YYYY-MM-DD', financialYear: 'jan-dec' },
      { code: 'HK', name: 'Hong Kong', phoneCode: '+852', currency: 'HKD', dateFormat: 'DD/MM/YYYY', financialYear: 'apr-mar' },
      { code: 'TW', name: 'Taiwan', phoneCode: '+886', currency: 'TWD', dateFormat: 'YYYY/MM/DD', financialYear: 'jan-dec' },
    ]
  },
  {
    region: 'Middle East',
    countries: [
      { code: 'AE', name: 'United Arab Emirates', phoneCode: '+971', currency: 'AED', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'SA', name: 'Saudi Arabia', phoneCode: '+966', currency: 'SAR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'QA', name: 'Qatar', phoneCode: '+974', currency: 'QAR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'KW', name: 'Kuwait', phoneCode: '+965', currency: 'KWD', dateFormat: 'DD/MM/YYYY', financialYear: 'apr-mar' },
      { code: 'OM', name: 'Oman', phoneCode: '+968', currency: 'OMR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'BH', name: 'Bahrain', phoneCode: '+973', currency: 'BHD', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'IL', name: 'Israel', phoneCode: '+972', currency: 'ILS', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
    ]
  },
  {
    region: 'North America',
    countries: [
      { code: 'US', name: 'United States', phoneCode: '+1', currency: 'USD', dateFormat: 'MM/DD/YYYY', financialYear: 'jan-dec' },
      { code: 'CA', name: 'Canada', phoneCode: '+1', currency: 'CAD', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
    ]
  },
  {
    region: 'Europe',
    countries: [
      { code: 'GB', name: 'United Kingdom', phoneCode: '+44', currency: 'GBP', dateFormat: 'DD/MM/YYYY', financialYear: 'apr-mar' },
      { code: 'DE', name: 'Germany', phoneCode: '+49', currency: 'EUR', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'FR', name: 'France', phoneCode: '+33', currency: 'EUR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'IT', name: 'Italy', phoneCode: '+39', currency: 'EUR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'ES', name: 'Spain', phoneCode: '+34', currency: 'EUR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'NL', name: 'Netherlands', phoneCode: '+31', currency: 'EUR', dateFormat: 'DD-MM-YYYY', financialYear: 'jan-dec' },
      { code: 'BE', name: 'Belgium', phoneCode: '+32', currency: 'EUR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'AT', name: 'Austria', phoneCode: '+43', currency: 'EUR', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'PT', name: 'Portugal', phoneCode: '+351', currency: 'EUR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'IE', name: 'Ireland', phoneCode: '+353', currency: 'EUR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'FI', name: 'Finland', phoneCode: '+358', currency: 'EUR', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'GR', name: 'Greece', phoneCode: '+30', currency: 'EUR', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'CH', name: 'Switzerland', phoneCode: '+41', currency: 'CHF', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'SE', name: 'Sweden', phoneCode: '+46', currency: 'SEK', dateFormat: 'YYYY-MM-DD', financialYear: 'jan-dec' },
      { code: 'NO', name: 'Norway', phoneCode: '+47', currency: 'NOK', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'DK', name: 'Denmark', phoneCode: '+45', currency: 'DKK', dateFormat: 'DD-MM-YYYY', financialYear: 'jan-dec' },
      { code: 'PL', name: 'Poland', phoneCode: '+48', currency: 'PLN', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'CZ', name: 'Czech Republic', phoneCode: '+420', currency: 'CZK', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'HU', name: 'Hungary', phoneCode: '+36', currency: 'HUF', dateFormat: 'YYYY.MM.DD', financialYear: 'jan-dec' },
      { code: 'RO', name: 'Romania', phoneCode: '+40', currency: 'RON', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'RU', name: 'Russia', phoneCode: '+7', currency: 'RUB', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
      { code: 'TR', name: 'Turkey', phoneCode: '+90', currency: 'TRY', dateFormat: 'DD.MM.YYYY', financialYear: 'jan-dec' },
    ]
  },
  {
    region: 'Oceania',
    countries: [
      { code: 'AU', name: 'Australia', phoneCode: '+61', currency: 'AUD', dateFormat: 'DD/MM/YYYY', financialYear: 'jul-jun' },
      { code: 'NZ', name: 'New Zealand', phoneCode: '+64', currency: 'NZD', dateFormat: 'DD/MM/YYYY', financialYear: 'apr-mar' },
    ]
  },
  {
    region: 'Africa',
    countries: [
      { code: 'ZA', name: 'South Africa', phoneCode: '+27', currency: 'ZAR', dateFormat: 'DD/MM/YYYY', financialYear: 'mar-feb' },
      { code: 'NG', name: 'Nigeria', phoneCode: '+234', currency: 'NGN', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'KE', name: 'Kenya', phoneCode: '+254', currency: 'KES', dateFormat: 'DD/MM/YYYY', financialYear: 'jul-jun' },
      { code: 'EG', name: 'Egypt', phoneCode: '+20', currency: 'EGP', dateFormat: 'DD/MM/YYYY', financialYear: 'jul-jun' },
    ]
  },
  {
    region: 'South America',
    countries: [
      { code: 'BR', name: 'Brazil', phoneCode: '+55', currency: 'BRL', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'MX', name: 'Mexico', phoneCode: '+52', currency: 'MXN', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'AR', name: 'Argentina', phoneCode: '+54', currency: 'ARS', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'CL', name: 'Chile', phoneCode: '+56', currency: 'CLP', dateFormat: 'DD-MM-YYYY', financialYear: 'jan-dec' },
      { code: 'CO', name: 'Colombia', phoneCode: '+57', currency: 'COP', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
      { code: 'PE', name: 'Peru', phoneCode: '+51', currency: 'PEN', dateFormat: 'DD/MM/YYYY', financialYear: 'jan-dec' },
    ]
  },
];

// Flatten all countries for easy lookup
export const ALL_COUNTRIES = COUNTRY_REGIONS.flatMap(region =>
  region.countries.map(country => ({ ...country, region: region.region }))
);

// Get country by code
export const getCountryByCode = (code) => {
  return ALL_COUNTRIES.find(c => c.code === code);
};

// Get country defaults for settings
export const getCountryDefaults = (countryCode) => {
  const country = getCountryByCode(countryCode);
  if (!country) {
    return {
      phoneCode: '+1',
      currency: 'USD',
      dateFormat: 'MM/DD/YYYY',
      financialYear: 'jan-dec'
    };
  }
  return {
    phoneCode: country.phoneCode,
    currency: country.currency,
    dateFormat: country.dateFormat,
    financialYear: country.financialYear
  };
};

// Currency data with symbols and codes
export const CURRENCIES = {
  INR: { code: 'INR', symbol: '₹', name: 'Indian Rupee', locale: 'en-IN' },
  USD: { code: 'USD', symbol: '$', name: 'US Dollar', locale: 'en-US' },
  EUR: { code: 'EUR', symbol: '€', name: 'Euro', locale: 'de-DE' },
  GBP: { code: 'GBP', symbol: '£', name: 'British Pound', locale: 'en-GB' },
  JPY: { code: 'JPY', symbol: '¥', name: 'Japanese Yen', locale: 'ja-JP' },
  CNY: { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', locale: 'zh-CN' },
  AUD: { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', locale: 'en-AU' },
  CAD: { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', locale: 'en-CA' },
  CHF: { code: 'CHF', symbol: 'Fr', name: 'Swiss Franc', locale: 'de-CH' },
  SGD: { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', locale: 'en-SG' },
  AED: { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', locale: 'ar-AE' },
  SAR: { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal', locale: 'ar-SA' },
  MYR: { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit', locale: 'ms-MY' },
  THB: { code: 'THB', symbol: '฿', name: 'Thai Baht', locale: 'th-TH' },
  IDR: { code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah', locale: 'id-ID' },
  PHP: { code: 'PHP', symbol: '₱', name: 'Philippine Peso', locale: 'en-PH' },
  PKR: { code: 'PKR', symbol: '₨', name: 'Pakistani Rupee', locale: 'en-PK' },
  BDT: { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka', locale: 'bn-BD' },
  LKR: { code: 'LKR', symbol: 'Rs', name: 'Sri Lankan Rupee', locale: 'si-LK' },
  NPR: { code: 'NPR', symbol: 'रू', name: 'Nepalese Rupee', locale: 'ne-NP' },
  ZAR: { code: 'ZAR', symbol: 'R', name: 'South African Rand', locale: 'en-ZA' },
  BRL: { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', locale: 'pt-BR' },
  MXN: { code: 'MXN', symbol: '$', name: 'Mexican Peso', locale: 'es-MX' },
  RUB: { code: 'RUB', symbol: '₽', name: 'Russian Ruble', locale: 'ru-RU' },
  KRW: { code: 'KRW', symbol: '₩', name: 'South Korean Won', locale: 'ko-KR' },
  TRY: { code: 'TRY', symbol: '₺', name: 'Turkish Lira', locale: 'tr-TR' },
  NZD: { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar', locale: 'en-NZ' },
  SEK: { code: 'SEK', symbol: 'kr', name: 'Swedish Krona', locale: 'sv-SE' },
  NOK: { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone', locale: 'nb-NO' },
  DKK: { code: 'DKK', symbol: 'kr', name: 'Danish Krone', locale: 'da-DK' },
  HKD: { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar', locale: 'zh-HK' },
  TWD: { code: 'TWD', symbol: 'NT$', name: 'Taiwan Dollar', locale: 'zh-TW' },
  QAR: { code: 'QAR', symbol: '﷼', name: 'Qatari Riyal', locale: 'ar-QA' },
  KWD: { code: 'KWD', symbol: 'د.ك', name: 'Kuwaiti Dinar', locale: 'ar-KW' },
  OMR: { code: 'OMR', symbol: '﷼', name: 'Omani Rial', locale: 'ar-OM' },
  BHD: { code: 'BHD', symbol: '.د.ب', name: 'Bahraini Dinar', locale: 'ar-BH' },
  ILS: { code: 'ILS', symbol: '₪', name: 'Israeli Shekel', locale: 'he-IL' },
  PLN: { code: 'PLN', symbol: 'zł', name: 'Polish Zloty', locale: 'pl-PL' },
  CZK: { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna', locale: 'cs-CZ' },
  HUF: { code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint', locale: 'hu-HU' },
  RON: { code: 'RON', symbol: 'lei', name: 'Romanian Leu', locale: 'ro-RO' },
  NGN: { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', locale: 'en-NG' },
  KES: { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling', locale: 'en-KE' },
  EGP: { code: 'EGP', symbol: 'E£', name: 'Egyptian Pound', locale: 'ar-EG' },
  ARS: { code: 'ARS', symbol: '$', name: 'Argentine Peso', locale: 'es-AR' },
  CLP: { code: 'CLP', symbol: '$', name: 'Chilean Peso', locale: 'es-CL' },
  COP: { code: 'COP', symbol: '$', name: 'Colombian Peso', locale: 'es-CO' },
  PEN: { code: 'PEN', symbol: 'S/', name: 'Peruvian Sol', locale: 'es-PE' },
};

// Get currency by code
export const getCurrencyByCode = (code) => {
  return CURRENCIES[code] || CURRENCIES.USD;
};

// Get country by phone code (first match)
export const getCountryByPhoneCode = (phoneCode) => {
  return ALL_COUNTRIES.find(c => c.phoneCode === phoneCode);
};

// Phone code list sorted by country name, for dropdown
export const PHONE_CODE_LIST = ALL_COUNTRIES
  .map(c => ({ code: c.code, name: c.name, phoneCode: c.phoneCode }))
  .sort((a, b) => a.name.localeCompare(b.name));

// Get currency by country code
export const getCurrencyByCountry = (countryCode) => {
  const country = getCountryByCode(countryCode);
  if (country) {
    return CURRENCIES[country.currency] || CURRENCIES.USD;
  }
  return CURRENCIES.USD;
};

// Timezone → country code mapping (primary + common alternative timezones)
// Used to detect user's country from OS timezone for phone code default
const TIMEZONE_TO_COUNTRY = {
  // South Asia
  'Asia/Kolkata': 'IN', 'Asia/Calcutta': 'IN',
  'Asia/Karachi': 'PK',
  'Asia/Dhaka': 'BD', 'Asia/Dacca': 'BD',
  'Asia/Colombo': 'LK',
  'Asia/Kathmandu': 'NP', 'Asia/Katmandu': 'NP',
  // Southeast Asia
  'Asia/Singapore': 'SG',
  'Asia/Kuala_Lumpur': 'MY',
  'Asia/Bangkok': 'TH',
  'Asia/Jakarta': 'ID', 'Asia/Makassar': 'ID', 'Asia/Jayapura': 'ID',
  'Asia/Manila': 'PH',
  'Asia/Ho_Chi_Minh': 'VN', 'Asia/Saigon': 'VN',
  // East Asia
  'Asia/Tokyo': 'JP',
  'Asia/Shanghai': 'CN', 'Asia/Chongqing': 'CN', 'Asia/Urumqi': 'CN',
  'Asia/Seoul': 'KR',
  'Asia/Hong_Kong': 'HK',
  'Asia/Taipei': 'TW',
  // Middle East
  'Asia/Dubai': 'AE',
  'Asia/Riyadh': 'SA',
  'Asia/Qatar': 'QA', 'Asia/Doha': 'QA',
  'Asia/Kuwait': 'KW',
  'Asia/Muscat': 'OM',
  'Asia/Bahrain': 'BH',
  'Asia/Jerusalem': 'IL', 'Asia/Tel_Aviv': 'IL',
  // North America
  'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US',
  'America/Los_Angeles': 'US', 'America/Phoenix': 'US', 'America/Anchorage': 'US',
  'Pacific/Honolulu': 'US', 'America/Detroit': 'US', 'America/Indiana/Indianapolis': 'US',
  'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'America/Edmonton': 'CA',
  'America/Winnipeg': 'CA', 'America/Halifax': 'CA', 'America/St_Johns': 'CA',
  // Europe
  'Europe/London': 'GB',
  'Europe/Berlin': 'DE',
  'Europe/Paris': 'FR',
  'Europe/Rome': 'IT',
  'Europe/Madrid': 'ES',
  'Europe/Amsterdam': 'NL',
  'Europe/Brussels': 'BE',
  'Europe/Vienna': 'AT',
  'Europe/Lisbon': 'PT',
  'Europe/Dublin': 'IE',
  'Europe/Helsinki': 'FI',
  'Europe/Athens': 'GR',
  'Europe/Zurich': 'CH',
  'Europe/Stockholm': 'SE',
  'Europe/Oslo': 'NO',
  'Europe/Copenhagen': 'DK',
  'Europe/Warsaw': 'PL',
  'Europe/Prague': 'CZ',
  'Europe/Budapest': 'HU',
  'Europe/Bucharest': 'RO',
  'Europe/Moscow': 'RU', 'Europe/Samara': 'RU', 'Asia/Yekaterinburg': 'RU',
  'Europe/Istanbul': 'TR',
  // Oceania
  'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Australia/Brisbane': 'AU',
  'Australia/Perth': 'AU', 'Australia/Adelaide': 'AU', 'Australia/Hobart': 'AU',
  'Pacific/Auckland': 'NZ',
  // Africa
  'Africa/Johannesburg': 'ZA',
  'Africa/Lagos': 'NG',
  'Africa/Nairobi': 'KE',
  'Africa/Cairo': 'EG',
  // South America
  'America/Sao_Paulo': 'BR', 'America/Fortaleza': 'BR', 'America/Manaus': 'BR',
  'America/Mexico_City': 'MX', 'America/Cancun': 'MX', 'America/Tijuana': 'MX',
  'America/Argentina/Buenos_Aires': 'AR', 'America/Buenos_Aires': 'AR',
  'America/Santiago': 'CL',
  'America/Bogota': 'CO',
  'America/Lima': 'PE',
};

// Get country code from user's OS timezone
export const getCountryByTimezone = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return TIMEZONE_TO_COUNTRY[tz] || null;
  } catch {
    return null;
  }
};

// Financial year options
export const FINANCIAL_YEARS = {
  'jan-dec': { label: 'January - December', startMonth: 1 },
  'apr-mar': { label: 'April - March', startMonth: 4 },
  'jul-jun': { label: 'July - June', startMonth: 7 },
  'oct-sep': { label: 'October - September', startMonth: 10 },
  'mar-feb': { label: 'March - February', startMonth: 3 },
};

// Date format options
export const DATE_FORMATS = [
  { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY', example: '25-12-2025', badge: 'Recommended', badgeColor: 'green' },
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY', example: '25/12/2025' },
  { value: 'MM-DD-YYYY', label: 'MM-DD-YYYY', example: '12-25-2025', badge: 'US format', badgeColor: 'blue' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD', example: '2025-12-25', badge: 'ISO 8601', badgeColor: 'purple' },
  { value: 'DD Mon YYYY', label: 'DD Mon YYYY', example: '25 Dec 2025', badge: 'Most readable', badgeColor: 'amber' },
  { value: 'Mon DD, YYYY', label: 'Mon DD, YYYY', example: 'Dec 25, 2025' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY', example: '12/25/2025' },
  { value: 'DD.MM.YYYY', label: 'DD.MM.YYYY', example: '25.12.2025' },
  { value: 'YYYY/MM/DD', label: 'YYYY/MM/DD', example: '2025/12/25' },
  { value: 'YYYY.MM.DD', label: 'YYYY.MM.DD', example: '2025.12.25' },
];
